import { TABLE_STATUS } from '@components/table/constants.ts';
import type { PaginationInfo } from '@types';

export const COMPLETION_METHOD = {
    Standard: 'Standard',
    AdaptiveQuiz: 'AdaptiveQuiz',
    FinalQuiz: 'FinalQuiz',
    OnboardTask: 'OnboardTask',
    Exemption: 'Exemption',
    AdaptiveQuizWithFinalQuizRequired: 'AdaptiveQuizWithFinalQuizRequired',
    StandardFromRelatedPathway: 'StandardFromRelatedPathway',
    AdaptiveQuizFromRelatedPathway: 'AdaptiveQuizFromRelatedPathway',
    OnboardTaskFromRelatedPathway: 'OnboardTaskFromRelatedPathway',
    ExemptionFromRelatedPathway: 'ExemptionFromRelatedPathway',
} as const;

export type CompletionMethod = (typeof COMPLETION_METHOD)[keyof typeof COMPLETION_METHOD];

export const PATHWAY_LEARNING_STATUS = {
    Completed: TABLE_STATUS.COMPLETED,
    Passed: TABLE_STATUS.PASSED,
    Failed: TABLE_STATUS.FAILED,
} as const;

export type PathwayLearningStatus = (typeof PATHWAY_LEARNING_STATUS)[keyof typeof PATHWAY_LEARNING_STATUS];

export const PATHWAY_CATEGORY = {
    Topic: 'Topic',
    Task: 'Task',
    Course: 'Course',
} as const;

export type PathwayCategory = (typeof PATHWAY_CATEGORY)[keyof typeof PATHWAY_CATEGORY];

export const PATHWAY_TYPE = {
    Learning: 'Learning',
    Assessment: 'Assessment',
    Survey: 'Survey',
} as const;

export type PathwayType = (typeof PATHWAY_TYPE)[keyof typeof PATHWAY_TYPE];

export const INITIAL_PAGINATION_INFO: PaginationInfo = {
    maxPageSize: 10,
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
};
